import React from 'react';

import Move from 'assets/icons/move.svg';

function DragButton({...props}) {
  return <img src={Move} alt="move" {...props} />;
}

export default DragButton;
